function createModel(type) {
  function create(opts) {
    const {
      attrName,
      objectType
    } = opts || {};
    return {
      type,
      attrName,
      objectType
    };
  }
  return {
    TYPE: type,
    create
  };
}
export default {
  createModel
};